//@flow
import type { AppState } from 'modules/rootReducer';
import type { GalleryImageType, RecommendedScreenType } from 'types/common';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { EventSelector } from 'modules/event/selector';
import { HomeSelector } from 'modules/home/selector';
import { RestaurantMapper } from 'mappers/restaurant';

const getMenuCategories = (
  state: AppState
): Array<RestaurantCategory> | null => {
  const categories = state.restaurant.categories;
  if (categories) {
    return categories;
    // return filter(categories, { status: 'A' });
  } else {
    return null;
  }
};

const getCategoryLoadingState = (state: AppState): boolean => {
  return state.restaurant.loading.categories;
};

const getCategoryError = (state: AppState): string | null => {
  return state.restaurant.error.categories;
};

const getGallery = (state: AppState): Array<GalleryImageType> | null => {
  return state.restaurant.gallery;
};

const getGalleryLoading = (state: AppState): boolean => {
  return state.restaurant.loading.gallery;
};

const getGalleryError = (state: AppState): string | null => {
  return state.restaurant.error.gallery;
};

const getAllRestaurants = (state: AppState): Array<RecommendedScreenType> => {
  return state.restaurant.allRestaurants;
};

const getAllRestaurantsLoading = (state: AppState): boolean => {
  return state.restaurant.loading.allRestaurants;
};

const getAllRestaurantsError = (state: AppState): string | null => {
  return state.restaurant.error.allRestaurants;
};

const getBanner = (state: AppState): Array<Restaurant> | null => {
  return state.restaurant.banner;
};

const getBannerLoading = (state: AppState): boolean => {
  return state.restaurant.loading.banner;
};

const getBannerError = (state: AppState): string | null => {
  return state.restaurant.error.banner;
};

const getBeer = (state: AppState): Array | null => {
  return state.restaurant.beer;
};
const getBeerLoading = (state: AppState): boolean => {
  return state.restaurant.loading.beer;
};

const getBeerError = (state: AppState): string | null => {
  return state.restaurant.error.beer;
};

const isRestaurantDetailsPageLoading = (state: AppState): boolean => {
  return (
    HomeSelector.getContactsLoading(state) ||
    HomeSelector.getVerticalsLoading(state) ||
    HomeSelector.getSiteSettingsLoading(state) ||
    CmsPagesSelector.isCmsPageLoading(state) ||
    RestaurantSelector.getGalleryLoading(state) ||
    RestaurantSelector.getBannerLoading(state) ||
    EventSelector.getUpcomingEventsLoading(state) ||
    getCategoryLoadingState(state) ||
    getBannerLoading(state) ||
    getGalleryLoading(state) ||
    getBeerLoading(state)
  );
};

const getSisterRestaurantsData = (
  state: AppState,
  defaultOutletSlug: string
): Array<RecommendedScreenType> => {
  return RestaurantMapper.mapSisterRestaurantData(state, defaultOutletSlug);
};

export const RestaurantSelector = {
  getMenuCategories,
  getCategoryLoadingState,
  getCategoryError,
  getGallery,
  getGalleryLoading,
  getGalleryError,
  getAllRestaurants,
  getAllRestaurantsLoading,
  getAllRestaurantsError,
  getBanner,
  getBannerLoading,
  getBannerError,
  isRestaurantDetailsPageLoading,
  getSisterRestaurantsData,
  getBeer,
  getBeerError,
  getBeerLoading,
};
